import { CuttingStandardCutoutSlot } from 'cloud-shared-lib';
import { CutoutTypeEnum } from './cutting-panel-outline.model';

export class CuttingStandardCutout {
  id: number;
  name: string;
  height: number;
  width: number;
  radius: number;
  fileName?: string;
  type: CutoutTypeEnum;
  readonly: boolean;
  availableSlotId?: number;
  availableSlot?: CuttingStandardCutoutSlot;
  slots: CuttingStandardCutoutSlot[] = [];
  fragmentParams?: StandardCutoutFragmentParams;
  imageS3Key?: string;
  fragmentImageS3Key?: string;
  imageLink?: string;
  fragmentImageLink?: string;
}

export interface StandardCutoutFragmentParams {
  x: number;
  y: number;
}

export enum StandardCutoutAvailablePlates {
  Face,
  Back,
  FaceAndBack,
}
